import script from "./ContentDescription.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContentDescription.vue?vue&type=script&lang=ts&setup=true"

import "./ContentDescription.vue?vue&type=style&index=0&id=298cb5e2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-298cb5e2"]])

export default __exports__